module.exports = __webpack_public_path__ + "img/DE00187.477dffe3.png";